import { render, staticRenderFns } from "./RaceDetails.vue?vue&type=template&id=d4cb1562&"
import script from "./RaceDetails.vue?vue&type=script&lang=js&"
export * from "./RaceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports